import type { ContentSummary } from 'api/new-analytics/types';
import NumberUtil from 'utils/number';

export function getReportContentMetricValue(
  summary: ContentSummary | undefined,
  metricKey: string,
): string | undefined {
  if (!summary) {
    return undefined;
  }

  switch (metricKey) {
    case 'engagement_rate':
      return summary.avg_engagement_rate != null
        ? `${NumberUtil.format(summary.avg_engagement_rate, {
            maximumFractionDigits: 2,
          })}%`
        : undefined;
    case 'engagements':
      return formatSummaryNumber(summary.total_engagements);
    case 'likes':
      return formatSummaryNumber(summary.total_likes);
    case 'comments':
      return formatSummaryNumber(summary.total_comments);
    case 'shares':
      return formatSummaryNumber(summary.total_shares);
    case 'reach':
      return formatSummaryNumber(summary.total_reach);
    case 'impressions':
      return formatSummaryNumber(summary.total_views);
    case 'views':
      return formatSummaryNumber(summary.total_views);
    case 'video_views':
      return formatSummaryNumber(summary.total_video_views);
    case 'reactions':
      return formatSummaryNumber(summary.total_reactions);
    case 'clicks':
      return formatSummaryNumber(summary.total_clicks);
    case 'saves':
      return formatSummaryNumber(summary.total_saves);
    default:
      return undefined;
  }
}

function formatSummaryNumber(value: number | undefined): string | undefined {
  if (value == null) {
    return undefined;
  }
  return NumberUtil.compact(value);
}
